module.exports = __webpack_public_path__ + "static/media/icon_500-x-500.1c95e952.png";